module.exports = __webpack_public_path__ + "static/img/mi_colegio_c_font.b0b30bfe.svg";